import DashboardTitleComponent from "../../custom/DashboardTitleComponent";
import AdminDaerahData from "../../data/AdminDaerahData";

const AdminDaerahMenu = () => {
  return (
    <div>
      <DashboardTitleComponent text={"Admin Daerah Menu"} />
      <AdminDaerahData />
    </div>
  );
};

export default AdminDaerahMenu;
